// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"c2c06695","205":"8c970a51","614":"195f856c","973":"72d2c38c"}[chunkId] + ".chunk.js";
};